<template>
  <div class="user-select-component">
    <div class="form-group">
      <label for="user_search">User Search</label>
      <input @input="doSearch()" type="text" class="form-control" v-model="search" name="user_search" id="user_search" placeholder="Start typing...">
    </div>

    <span v-if="loading" class="spinner-border mb-4" role="status" aria-hidden="true"></span>

    <ul v-if="results" class="list-group">
      <li v-for="user in results" :key="user.id" class="list-group-item cursor-pointer" @click="selectUser(user)">#{{ user.id }} - {{ user.name }} ({{ user.email }})</li>
    </ul>

    <div v-if="user" class="form-group">
      <label>Selected User</label>
      <input type="text" class="form-control" readonly :value="'#' + user.id + ' - ' + user.name">
      <input v-if="createInput" type="hidden" name="user_id" :value="user.id">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      user: null,
      search: null,
      results: null,
    };
  },

  props: {
    preloadUser: {
      type: Object,
      default: null,
    },

    createInput: {
      type: Boolean,
      default: true,
    },

    userType: {
      type: String,
      default: null,
    },
    prospect: {
      type: Boolean,
      default: false,
    }
  },

  watch: {
    user(user) {
      this.$emit('user-selected', user);
    },
  },

  created() {
    if (this.preloadUser) {
      this.user = this.preloadUser;
    }
  },

  methods: {
    doSearch() {
      if (this.search.length < 3) {
        return;
      }

      this.loading = true;
      this.results = null;

      axios.post(window.api_url + '/admin/users/get', {
        filters: {
          search: this.search,
          user_type: this.userType,
          prospect: this.prospect,
        },
      })
      .then(res => {
        if (res.data && res.data.success) {
          this.results = res.data.users.data;
        }
      })
      .catch(err => {
        //
      })
      .finally(() => {
        this.loading = false;
      });
    },

    selectUser(user) {
      this.user = user;
      this.results = null;
      this.search = null;
    },
  },
};
</script>
